/**
 * Конфигурационные константы для компонентов
 * Централизация магических чисел для лучшей поддержки
 */

/**
 * Настройки Swiper компонента
 */
export const SWIPER_CONFIG = {
  /** Задержка синхронизации слайдера (ms) */
  SYNC_DELAY: 100,
  /** Задержка обновления после взаимодействия (ms) */
  UPDATE_DELAY: 200,
  /** Задержка анимации перехода (ms) */
  ANIMATION_DELAY: 350,
  /** Задержка полной инициализации (ms) */
  INIT_DELAY: 500,
  /** Скорость анимации слайда (ms) */
  SLIDE_SPEED: 300,
  /** Угол касания для срабатывания свайпа */
  TOUCH_ANGLE: 45,
  /** Коэффициент сопротивления */
  RESISTANCE_RATIO: 0.85,
  /** Breakpoints для адаптивности */
  BREAKPOINTS: {
    320: {
      slidesPerView: 1.3,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 2.3,
      spaceBetween: 12,
    },
  },
} as const

/**
 * Настройки системы таймеров заказов
 */
export const TIMER_CONFIG = {
  /** Таймаут оплаты заказа (15 минут в ms) */
  PAYMENT_TIMEOUT_MS: 15 * 60 * 1000,
  /** Интервал обновления таймера (1 секунда в ms) */
  UPDATE_INTERVAL_MS: 1000,
  /** Делители времени для форматирования */
  TIME_DIVISORS: {
    MINUTE: 60_000,
    SECOND: 1000,
    HOUR: 60,
  },
} as const

/**
 * Настройки отображения заказов
 */
export const ORDER_DISPLAY_CONFIG = {
  /** Минимальное количество заказов для включения свайпа */
  MIN_ORDERS_FOR_SWIPE: 1,
  /** Значение по умолчанию для ID заказа */
  DEFAULT_ORDER_ID: 'N/A',
  /** Значение по умолчанию для таймера */
  DEFAULT_TIMER_VALUE: '00:00',
} as const

